import PropTypes from 'prop-types'
import { Alert, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import Button from '../../../components/button'

const TRANSLATION_PREFIX = 'charities.dashboard.stripe.verificationRequirements'

export default function CharityVerificationRequirementsModal({
  show,
  onHide,
  onContinue,
  continuing,
  error,
}) {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t(`${TRANSLATION_PREFIX}.title`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        ) : null}
        <p className="fw-semibold mb-1">
          {t(`${TRANSLATION_PREFIX}.eligibilityHeading`)}
        </p>
        <p className="mb-4">{t(`${TRANSLATION_PREFIX}.eligibilityText`)}</p>

        <p className="fw-semibold mb-3">
          {t(`${TRANSLATION_PREFIX}.submitHeading`)}
        </p>

        <ul className="mb-0 ps-3">
          <li className="mb-2">{t(`${TRANSLATION_PREFIX}.nonprofitProof`)}</li>
          <li className="mb-2">
            {t(`${TRANSLATION_PREFIX}.governingDocuments`)}
          </li>
          <li className="mb-2">
            <strong>{t(`${TRANSLATION_PREFIX}.authorizedRepTitle`)}</strong>
            <ul className="mt-1 mb-0">
              <li>{t(`${TRANSLATION_PREFIX}.authorizedRepDetails`)}</li>
              <li>{t(`${TRANSLATION_PREFIX}.authorizedRepOption1`)}</li>
              <li>{t(`${TRANSLATION_PREFIX}.authorizedRepOption2`)}</li>
            </ul>
          </li>
          <li className="mb-2">
            <strong>{t(`${TRANSLATION_PREFIX}.bankingTitle`)}</strong>
            <ul className="mt-1 mb-0">
              <li>{t(`${TRANSLATION_PREFIX}.bankingVoidCheck`)}</li>
              <li>{t(`${TRANSLATION_PREFIX}.bankingRouting`)}</li>
              <li>{t(`${TRANSLATION_PREFIX}.bankingAccount`)}</li>
            </ul>
          </li>
          <li className="mb-2">{t(`${TRANSLATION_PREFIX}.mailingAddress`)}</li>
          <li>{t(`${TRANSLATION_PREFIX}.website`)}</li>
        </ul>
      </Modal.Body>
      <Modal.Footer className="justify-content-end">
        <Button variant="secondary" onClick={onHide} disabled={continuing}>
          {t(`${TRANSLATION_PREFIX}.closeButton`)}
        </Button>
        <Button variant="primary" onClick={onContinue} disabled={continuing}>
          {t(`${TRANSLATION_PREFIX}.continueButton`)}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

CharityVerificationRequirementsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  continuing: PropTypes.bool,
  error: PropTypes.string,
}

CharityVerificationRequirementsModal.defaultProps = {
  continuing: false,
  error: null,
}
